import React, { useEffect, useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import { useNavigate } from "react-router-dom";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import { useDispatch, useSelector } from "react-redux";
import { listCustomerMasterAsync } from "../../../../redux/features/customerMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import CustomTable from "../../../../components/common/CustomTable";
import { BsPencilSquare } from "react-icons/bs";
import toast from "react-hot-toast";
import { changeStatus } from "../../../../Api/dispatch/customer-dispatch";
import DownloadReportButton from "../../../../components/common/DownloadReportButton";
import { customerMasterReportAsync } from "../../../../redux/features/reportSlice";
import * as XLSX from "xlsx";
import moment from "moment/moment";
import { useBoolean } from "../../../../Hooks/useBoolean";

export default function CustomerMasterList() {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const customerMaster = useSelector((state) => state.customerMaster);
   const customerMasterList = customerMaster?.dataList;

   const [records, setRecords] = useState([]);
   const [isActiveLoading, setIsActiveLoading] = useState({
      id: "",
      status: false,
   });

   const reportPopup = useBoolean();

   useEffect(() => {
      if (customerMasterList) setRecords(customerMasterList);
   }, [customerMasterList]);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         listCustomerMasterAsync({
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
         })
      );
   }, [dispatch]);

   // Handle active inactive
   const handleActiveInactive = (customer) => {
      setIsActiveLoading({ id: customer?.id, status: true });
      changeStatus({ id: customer?.id, status: customer?.is_active === "1" ? "0" : "1" })
         .then((res) => {
            setIsActiveLoading({ id: customer?.id, status: false });
            dispatch(listCustomerMasterAsync({}));
            toast.success(
               `customer ${customer?.is_active === "1" ? "deactivated" : "activated"}`
            );
         })
         .catch((error) => {
            setIsActiveLoading({ id: customer?.id, status: false });
            toast.error(
               `Failed to ${
                  customer?.is_active === "1" ? "deactivate" : "activate"
               } customer`
            );
         });
   };

   //  Download fleet Report
   const handleDownloadReport = (data) => {
      dispatch(backdropLoadingAction(true));

      dispatch(
         customerMasterReportAsync({
            data: data,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: (report) => {
               const headers = [
                  "S. No.",
                  "Customer Name",
                  "Material customer name (Origin)",
                  "Material customer name (Destination)",
                  "Address (1,2,3… Multiple addition required)",
                  "Customer Contact Name (1,2,3… Multiple addition required)",
                  "Customer Contact No. (1,2,3… Multiple addition required)",
                  "Customer Mail Address (1,2,3… Multiple addition required)",
                  "GST Details",
                  "Agreement Details (1,2,3… Multiple addition required)", // Main header for Agreement Details
                  "Location (1,2,3… Multiple addition required)",
                  "Lane name (1,2,3… Multiple addition required) (Lane Name = Cust.name#origin#destination#vehicleType#tonnage)",
                  "Origin",
                  "Destination",
                  "Rate",
                  "Express mode rate additional",
                  "Super express mode rate additional",
                  "Multiple loading location rate additional",
                  "Multiple unloading location rate additional",
                  "Detention Charge",
                  "Loading charges",
                  "Unloading charge",
                  "Miscellaneous charges",
                  "Brokerage charge",
                  "Miscellaneous Remarks",
               ];

               const subheaders = [
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "Start Date",
                  "End Date",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
               ];

               const customerMasterDataArr = [];
               const adhocCustomerMasterDataArr = [];

               let customerMasterMaxSubArrLength = 0;
               let customerMasterId = null;

               report?.customerMaster?.forEach?.((item, index) => {
                  customerMasterMaxSubArrLength = Math.max(
                     item?.documents?.length ?? 0,
                     item?.contact_personal_details?.length ?? 0,
                     item?.locations?.length ?? 0,
                     item?.lane?.length ?? 0
                  );

                  for (let i = 0; i < customerMasterMaxSubArrLength; i++) {
                     const arr = [];
                     arr.push(
                        customerMasterId === item?.id ? "-" : index + 1,
                        item?.name,
                        "-",
                        "-",
                        item?.address ?? "-",
                        item?.contact_personal_details?.[i]?.name,
                        item?.contact_personal_details?.[i]?.mobile,
                        item?.contact_personal_details?.[i]?.email,
                        item?.gst ?? "-",
                        moment(item?.documents?.[i]?.created_at).format("MMM Do YY"),
                        moment(item?.documents?.[i]?.created_at).format("MMM Do YY"),
                        item?.locations?.[i]?.name,
                        item?.lane?.[i]?.name,
                        item?.lane?.[i]?.origin, // origin
                        item?.lane?.[i]?.destination, // dfest
                        item?.lane?.[i]?.vend_trip_rate, // rate
                        item?.lane?.[i]?.cust_express_mode_rate_additional,
                        item?.lane?.[i]?.cust_super_express_mode_rate_additional,
                        item?.lane?.[i]?.cust_multiple_loading_location_rate_additional,
                        item?.lane?.[i]?.cust_multiple_unloading_location_rate_additional,
                        item?.lane?.[i]?.cust_detention_rate_additional,
                        item?.lane?.[i]?.cust_loading_charges,
                        item?.lane?.[i]?.cust_unloading_charge,
                        item?.lane?.[i]?.cust_miscellaneous_charges,
                        "-",
                        item?.lane?.[i]?.cust_miscellaneous_remarks
                     );
                     customerMasterId = item?.id;
                     customerMasterDataArr.push(arr);
                  }
               });

               console.log({ customerMasterDataArr });

               report?.adhocCustomerMaster?.forEach?.((item, index) => {
                  const arr = [];
                  arr.push(
                     report?.customerMaster?.length + index + 1,
                     item?.customername,
                     item?.material_contact_person_name_origin,
                     item?.material_customer_name_destination,
                     item?.address ?? "-",
                     "-",
                     "-",
                     "-",
                     "-",
                     "-",
                     "-", // location
                     item?.lane_name,
                     item?.origin_location_master?.name, // origin
                     item?.destination_location_master?.name, // dfest
                     "-", // rate
                     "-",
                     "-",
                     "-",
                     "-",
                     "-",
                     "-",
                     "-",
                     "-",
                     item?.brokerage_charge,
                     "-"
                  );
                  adhocCustomerMasterDataArr.push(arr);
               });

               // Combine headers and rows
               const sheetData = [
                  headers,
                  subheaders,
                  ...customerMasterDataArr,
                  ...adhocCustomerMasterDataArr,
               ];

               console.log({ report });
               const ws = XLSX.utils.aoa_to_sheet(sheetData);

               // Merging cells to create a header with sub-columns
               ws["!merges"] = [
                  { s: { r: 1, c: 9 }, e: { r: 1, c: 10 } }, // Merging cells for "Agreement Details"
               ];

               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "CUSTOMER_MASTER_REPORT.xlsx");
               dispatch(backdropLoadingAction(false));
               reportPopup.onFalse();
            },
         })
      );
   };

   const columns = [
      {
         name: "Customer Name",
         selector: (row) => row.name,
         sortable: true,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => (
            <div className="d-flex align-items-center">
               <button
                  className="btn"
                  onClick={() => navigate(`/customer-master/edit/${row?.id}`)}
               >
                  <BsPencilSquare
                     className="text-primary"
                     style={{ height: "1.5rem", width: "1.5rem" }}
                  />
               </button>
               <CustomToggleSwitch
                  checked={row?.is_active === "1"}
                  onChange={() => handleActiveInactive(row)}
                  isLoading={isActiveLoading.id === row?.id && isActiveLoading.status}
               />
            </div>
         ),
      },
   ];

   const handleFilter = (e) => {
      const searchText = e.target.value.toLowerCase();
      const filteredData = customerMasterList?.filter?.((item) => {
         return item?.name?.toLowerCase().includes(searchText);
      });
      setRecords(filteredData);
   };

   return (
      <div>
         <BodyHeader title="Customer Master List" />

         <div className="px-3">
            <div className=" d-flex justify-content-between">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />

               <DownloadReportButton
                  onDownloadReport={handleDownloadReport}
                  confirmPopup={reportPopup}
               />
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
